import   React               ,
       { useState            ,
         useEffect           }  from 'react';

import   classNames             from 'classnames';

import   styles                 from './ProductSheet_Price_Discount.module.scss';

import   Field                  from '../../widget/inputs/Field';
import   Select                 from '../../widget/inputs/Select';
import   WidgetFrame            from '../../widget/navigation/WidgetFrame';
import   CollapsiblePanel       from '../../widget/windows/CollapsiblePanel';
import   Toggle                 from '../../widget/inputs/Toggle';
import   Label                  from '../../widget/dataDisplay/labels/Label';

import { ProductPrice        ,
         ProductDiscount     ,
         initializedDiscount }  from '../../../dataTypes/productManagment/types';

export interface ProductSheet_Price_Discount_Props {
  price     : ProductPrice
  discount? : ProductDiscount;
  title     : string;
  width?    : string;
  onChange? : (newDiscount: ProductDiscount) => void;
  onResize? : () => void;
  onDelete? : () => void;
  open?     : boolean
}

export const ProductSheet_Price_Discount = ({ price             ,
                                              discount          ,
                                              title             ,
                                              width    = '100%' ,
                                              onChange          ,
                                              onResize          ,
                                              onDelete          ,
                                              open              }: ProductSheet_Price_Discount_Props) => {

  const isEditMode = !!discount;
  const initialDiscount = isEditMode ? discount : initializedDiscount();

  const [fields, setFields] = useState({
    id             : initialDiscount.id             || 0               ,
    active         : initialDiscount.active         || false           ,
    type           : initialDiscount.type           || 'Remise simple' ,
    condition      : initialDiscount.condition      || ''              ,
    value          : initialDiscount.value          || '0'             ,
    priceToApplyOn : initialDiscount.priceToApplyOn || 'Prix HT'       ,
    priceToPay     : initialDiscount.priceToPay     || 0               ,
  });


  const typeOptions = ['Remise simple', 'Sur statut', 'Sur événement'];

  const conditionOptions: Record<(typeof typeOptions)[number], string[]> = {
    'Remise simple' : [],
    'Sur statut'    : ['Tous', 'Découverte', 'Standard', 'Premium'],
    'Sur événement' : ['Black Friday', 'Soldes d\'hiver', 'Soldes d\'été'],
  };
  
  const priceToApplyOnOptions = ['Prix HT', 'Prix TTC'];

  useEffect(() => {

    calculatePriceToPay ();

  }, [price, fields]);


  const handleActiveChange = (newValue: boolean ) => {
  
    setFields( (prev) => {
	
      const updatedFields = { ...prev, active: newValue };

      notifyDiscountChange (updatedFields)

      return updatedFields;
    });
  }

  const handleTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {

    const newValue = e.target.value;

    setFields((prev) => {
      const updatedFields = { ...prev, type: newValue };

      const newType = newValue as keyof typeof conditionOptions;

      updatedFields.condition = conditionOptions[newType].length > 0 ? conditionOptions[newType][0] : '';

      notifyDiscountChange (updatedFields)

      return updatedFields;
    });
  }

  const handleConditionChange = (e: React.ChangeEvent<HTMLSelectElement>) => {

    const newValue = e.target.value;

    setFields((prev) => {
      const updatedFields = { ...prev, condition: newValue };

      notifyDiscountChange (updatedFields)

      return updatedFields;
    });
  }

  const handleValueChange = (e: React.ChangeEvent<HTMLInputElement> ) => {

    const newValue = e.target.value;

    setFields( (prev) => {

      const updatedFields = { ...prev, value: newValue };

      notifyDiscountChange (updatedFields)

      return updatedFields;
    });
  };

  const handlePriceToApplyOnChange = (e: React.ChangeEvent<HTMLSelectElement>) => {

    const newValue = e.target.value;

    setFields((prev) => {
      const updatedFields = { ...prev, priceToApplyOn: newValue };

      notifyDiscountChange (updatedFields)

      return updatedFields;
    });
  }

  const calculatePriceToPay = () => {

          let discountValue = 0;

          if (fields.value.includes('%'))
                {
                 const percentage = parseFloat(fields.value) / 100;

                 discountValue = fields.priceToApplyOn === 'Prix HT'
                                    ? price.basePrice    * percentage
                                    : price.priceWithTax * percentage;
                }
           else {
                 discountValue = parseFloat(fields.value);
                }

          let newPriceToPay = price.priceWithTax;

          if (fields.priceToApplyOn === 'Prix HT')
                {
                 const newBasePrice = price.basePrice - discountValue;
                 newPriceToPay = price.taxRate === -1 ? newBasePrice : newBasePrice * (1 + price.taxRate / 100);
                }
           else {
                 newPriceToPay = price.priceWithTax - discountValue;
                }

          if (!isNaN(newPriceToPay))
                {
                  setFields( (prev) => {
	
                    const updatedFields = { ...prev, priceToPay: newPriceToPay }

                    notifyDiscountChange (updatedFields)
					
					return updatedFields
                  });			   
                }
		   else {
                  setFields( (prev) => {
	
                    const updatedFields = { ...prev, priceToPay: price.priceWithTax }

                    notifyDiscountChange (updatedFields)
					
					return updatedFields
                  });			   
		        }

  };

  const notifyDiscountChange = (updatedFields: ProductDiscount) => {

     if (onChange)
      {
       onChange(updatedFields);
      }
  };

  return (
    <div className = {classNames(styles.root)}>
      <CollapsiblePanel title    = {title}
                        onDelete = {onDelete}
                        open     = {open}>
        <div className = {classNames(styles.contain)}>

          <div className = {classNames(styles.active)} >
            <WidgetFrame name              = 'Actif :'
                         labelTextPosition = "right"
                         classNameGrid     = {classNames(styles.grid_frame)}>
              <Toggle checked  = {fields.active}
                      onChange = {handleActiveChange}
                      form     = "switch" />
            </WidgetFrame>
          </div>

          <div className={classNames(styles.type)}>
            <WidgetFrame name              = 'Type :'
                         labelTextPosition = "right"
                         classNameGrid     = {classNames(styles.grid_frame)}>
              <Select choices      = {typeOptions}
                      value        = {fields.type}
                      onChange     = {handleTypeChange} />
            </WidgetFrame>
          </div>

        {
          fields.type !== 'Remise simple' &&
          <div className={classNames(styles.condition)}>
            <WidgetFrame name              = 'Condition :'
                         labelTextPosition = "right"
                         classNameGrid     = {classNames(styles.grid_frame2)}>
              <Select choices      = {conditionOptions[fields.type as keyof typeof conditionOptions] || []}
                      value        = {fields.condition}
                      onChange     = {handleConditionChange} />
            </WidgetFrame>
          </div>
        }

          <div className={classNames(styles.value)}>
            <WidgetFrame name              = 'Valeur :'
                         labelTextPosition = "right"
                         classNameGrid     = {classNames(styles.grid_frame)}>
              <Field type     = "text"
		             value    = {fields.value}
				  	 onChange = {handleValueChange} />
            </WidgetFrame>
          </div>

          <div className={classNames(styles.priceToApplyOn)}>
            <WidgetFrame name              = 'Prix cible :'
                         labelTextPosition = "right"
                         classNameGrid     = {classNames(styles.grid_frame)}>
              <Select choices      = {priceToApplyOnOptions}
                      value        = {fields.priceToApplyOn}
                      onChange     = {handlePriceToApplyOnChange} />
            </WidgetFrame>
          </div>
		  
        
          <div className={classNames(styles.priceToPay)}>
            <WidgetFrame name              = "Prix avec remises :"
                         labelTextPosition = "right"
                         classNameGrid     = {classNames(styles.grid_frame2)} >
              <div className={classNames(styles.oneLineDisplay)}>

              <Label value={fields.priceToPay.toFixed(2)} />
              &nbsp;
              €
              </div>
            </WidgetFrame>
          </div>
        
        </div>
      </CollapsiblePanel>
    </div>
  );

};

export default ProductSheet_Price_Discount;
